import { Component, computed, effect, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import * as authAactions from './store/auth/auth.actions';
import { HeaderComponent } from './shared/components/header/header.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { SignalRService } from './core/services/signalr.service';
import * as authSelectors from './store/auth/auth.selectors';
import { filter } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    CommonModule,
    ToastModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  store: Store = inject(Store);
  private signalRService: SignalRService = inject(SignalRService);
  public isAuth = toSignal(this.store.select(authSelectors.selectIsAuthenticated), { initialValue: false });
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private currentUrl = signal(this.location.path());

  isLoginPage = computed(() => this.currentUrl().startsWith('/login') || this.currentUrl().startsWith('/password-set') || this.currentUrl().startsWith('/forgot-password'));
  title = 'Alveri Sphere';

  showHeader = computed(() => this.isAuth() && !this.isLoginPage() && !this.currentUrl().startsWith('/onboarding') );
  
  constructor() {
    this.store.dispatch(authAactions.checkLogin());
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.currentUrl.set(this.location.path());
      });
    
    effect(() => {
      if (!this.isAuth()) {
        const url = this.currentUrl();
        if(url.startsWith('/password-set') || url.startsWith('/forgot-password')) {
            this.router.navigateByUrl(url);
        }
        else if (!url.startsWith('/login')) {
          this.router.navigate(['/login'], { queryParams: { redirectUrl: url } });
        }
      }
    });
  }

}
